import { Gallery } from "react-photoswipe-gallery";
import ThreadGalleryItem from "./ThreadGalleryItem";

interface IThreadGallery {
  documents?: any;
  isPrivate?: boolean;
  onRemoveFile?: any;
  editMode?: boolean;
  small?: boolean;
  exifData?: any[];
}
function ThreadGallery({
  documents,
  isPrivate,
  onRemoveFile,
  editMode,
  small = false,
  exifData,
}: IThreadGallery) {
  const containerStyle = isPrivate ? "flex gap-1" : "flex gap-1 justify-end";
  const list = (documents || []).map((file: any) => (
    <ThreadGalleryItem
      key={file.uri}
      file={file}
      onRemoveFile={() => onRemoveFile(file)}
      editMode={editMode}
      small={small}
      exifData={exifData}
    />
  ));

  if (!documents || documents.length < 1) {
    return null;
  }
  return (
    <Gallery withDownloadButton withCaption>
      <div className={containerStyle}>{list}</div>
    </Gallery>
  );
}

export default ThreadGallery;
